import {
  extend,
  ValidationObserver,
  ValidationProvider
} from "vee-validate";
import {
  messages
} from "vee-validate/dist/locale/id.json";
import * as rules from "vee-validate/dist/rules";
import Vue from "vue";
import VuetifyDialog from "vuetify-dialog";
import "vuetify-dialog/dist/vuetify-dialog.css";
import App from "./App.vue";
import Acl from "./plugins/acl";
import Axios from "./plugins/axios";
import vuetify from "./plugins/vuetify";
import Router from "./router";
import Store from "./store";
import {
  app
} from "./store/modules/app";
import "./util/dbflex";
import "./util/format";
import "./util/log";
import "./util/session";
import "./util/util";
import util from "./util/util";

// init VeeValidate
Object.keys(rules).forEach((rule) => {
  extend(rule, {
    ...rules[rule],
    message: messages[rule],
  });
});

extend("fully_required", {
  validate: (value) => {
    return !util.isEmpty(value);
  },
  message: (field) => {
    return `${field} harus diisi`;
  },
});

extend("same_as", {
  params: ['target'],
  validate(value, {
    target
  }) {
    return value === target;
  },
  message: (field) => {
    return `${field} tidak sama`;
  },
});

Vue.component("Validate", ValidationProvider);
Vue.component("ValidateAll", ValidationObserver);

// Layout
Vue.component("dashboard_layout", () =>
  import( /* webpackChunkName: "dashboard-layout" */ "@/layouts/dashboard.vue")
);
Vue.component("blank_layout", () =>
  import( /* webpackChunkName: "blank-layout" */ "@/layouts/blank.vue")
);

Vue.config.productionTip = false;
// init Vuetify-Dialog

Vue.use(VuetifyDialog, {
  context: {
    vuetify,
  },
  confirm: {
    actions: {
      false: app.confirmation.no,
      true: {
        text: app.confirmation.yes,
        color: "primary",
      },
    },
    title: app.confirmation.title,
    width: 400,
    persistent: true,
  },
});

new Vue({
  router: Router,
  store: Store,
  vuetify: vuetify,
  axios: Axios,
  acl: Acl,
  render: (h) => h(App),
}).$mount("#app");